import { render } from "./zfblist.vue?vue&type=template&id=1bc7ef38"
import script from "./zfblist.vue?vue&type=script&lang=js"
export * from "./zfblist.vue?vue&type=script&lang=js"

import exportComponent from "F:\\chatpc\\chatadmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__